module.exports = __webpack_public_path__ + "img/daka.1d102d7b.png";